import React from "react";

// Default components
import {defaultComponents} from "./../components/_default/interfaces/DefaultComponents"
import ContentRenderer from "./../components/_default/ContentRenderer"
import MetadataComponent from "./../components/_default/MetadataComponent";
import CheckNotFoundPage from "./../components/_default/CheckNotFoundPage";
import { useAppSelector, useAppDispatch } from "./../store/hooks"

window.defaultComponents = defaultComponents;

export default function Webpage12Lehte_ei_leitud() {
        const page_seo = {
                    seo_no_index: '1',
                    seo_og_url: 'veeb.infonurk.ee\/et\/*',
                    seo_og_type: 'website',
                    seo_twitter_card: 'summary_large_image',
                    seo_title: 'Lehte ei leitud - infonurk.ee',
                    canonical: 'https:\/\/infonurk.ee\/et\/*',
            }
    
    const dispatch = useAppDispatch();
    
    React.useEffect(() => {
        dispatch({
            type: "SET_WEBPAGE_ACTIVE",
            payload: "019c93cd-45af-7a6f-b1eb-9b27f952296d"
        });
    }, [])
    
    React.useEffect(() => {
        dispatch({
            type: "UPDATE_STRUCTURE",
            payload: {"webpageComponents":[1113,1133],"components":{"1113":{"id":1113,"uuid":"019cd7ac-3922-7061-b29e-843b59f464a9","language_id":null,"parent_id":null,"webpage_id":12,"type":"section","sort_order":0,"version":1,"isShared":false,"attributes":{"classes":"row","content_width_unit":"%","content_width_size":100,"styles":{"paddingTop":"60px","paddingLeft":"60px","paddingRight":"60px","paddingBottom":"60px"}},"childWebpageComponentRelations":[]},"1133":{"id":1133,"uuid":"019cd7ab-e833-72c1-9033-48d9ace9b889","language_id":1,"parent_id":null,"webpage_id":12,"type":"footer","sort_order":999999,"version":1,"isShared":true,"attributes":{"classes":"builder-footer","styles":[]},"childWebpageComponentRelations":[]}}}        });
    }, [])
    
    
    
    return (
        <>
            <CheckNotFoundPage/>
            <MetadataComponent page_seo={page_seo} />
            <ContentRenderer />
        </>
    );
}